var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70711 0.792893C2.31658 0.402369 1.68342 0.402369 1.29289 0.792893C0.902369 1.18342 0.902369 1.81658 1.29289 2.20711L3.71706 4.63127C2.28639 5.70737 1.03925 7.18543 0.105573 9.05279C-0.0351909 9.33432 -0.0351909 9.66569 0.105573 9.94722C2.26379 14.2637 6.09687 16.5 10 16.5C11.5552 16.5 13.0992 16.145 14.5306 15.4448L17.2929 18.2071C17.6834 18.5976 18.3166 18.5976 18.7071 18.2071C19.0976 17.8166 19.0976 17.1834 18.7071 16.7929L2.70711 0.792893ZM13.0138 13.928L11.2934 12.2076C10.9018 12.3951 10.4631 12.5 10 12.5C8.34315 12.5 7 11.1569 7 9.50001C7 9.03686 7.10495 8.59822 7.29237 8.20659L5.14838 6.06259C3.98778 6.8794 2.94721 8.02136 2.12966 9.5C3.99806 12.8792 7.03121 14.5 10 14.5C11.0134 14.5 12.0343 14.3112 13.0138 13.928Z",
    fill: "#747488"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5523 11.3955C17.0353 10.8402 17.4784 10.2088 17.8703 9.5C16.0019 6.12078 12.9687 4.5 9.99996 4.5C9.88796 4.5 9.77586 4.50231 9.66374 4.50693L7.87939 2.72258C8.57741 2.57451 9.28752 2.5 9.99996 2.5C13.9031 2.5 17.7362 4.73635 19.8944 9.05279C20.0352 9.33431 20.0352 9.66569 19.8944 9.94721C19.3504 11.0352 18.7 11.991 17.9689 12.8121L16.5523 11.3955Z",
    fill: "#747488"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedEye);
export default __webpack_public_path__ + "static/media/crossedEye.7552c6c0071391c03f016d97ead8fb67.svg";
export { ForwardRef as ReactComponent };